export * from './ResetPasswordSentMainProps'
